module.exports = __webpack_public_path__ + "static/media/increase-sales.bda14a3b.png";